import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "buttonsContainer",
  class: "q-row q-p-1 q-m-1"
}

import {inject} from "vue";
import {SmartSearchConfigInterface} from "@/core/types";

import MobileFiltersButton from '@/components/SerpPage/ResultsContainer/ButtonsContainer/MobileFiltersButton.vue'
import SortingButtonContainer from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButtonContainer.vue";
import ClearFiltersButton
  from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue"
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonsContainer',
  setup(__props) {

const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const {showSorting} = SmartSearchConfig.value.serp.sorting
const {showAsideFilters, showTopFilters} = SmartSearchConfig.value.serp.filters
const serpStore = useSerpResultsStore();
const mobileViewStore = useMobileViewStore();

const {noProductsToDisplay, noResultsState} = storeToRefs(serpStore)
const {isTabletView} = storeToRefs(mobileViewStore)


return (_ctx: any,_cache: any) => {
  return (_unref(showAsideFilters) || _unref(showTopFilters) || _unref(showSorting))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "q-col-12 q-col-md-6 q-col-xl-9" }, null, -1)),
        (_unref(noResultsState))
          ? (_openBlock(), _createBlock(ClearFiltersButton, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(noResultsState) || (_unref(showAsideFilters) || _unref(showTopFilters)))
          ? (_openBlock(), _createBlock(MobileFiltersButton, { key: 1 }))
          : _createCommentVNode("", true),
        (!_unref(noProductsToDisplay) && _unref(showSorting) && !_unref(isTabletView))
          ? (_openBlock(), _createBlock(SortingButtonContainer, { key: 2 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})